import React from 'react';
import styles from './styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload, faTimes } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import services from '../../../../services';

import { useDispatch } from "react-redux"
import { showMsgE as showMsgEAction} from '../../../../store/actions/snackbarActions.js';

const Card = ({ usuario, update, setLoading  }) => {

    const dispatch = useDispatch();
    const showMsgE = (msg) => dispatch(showMsgEAction(msg));

    const apagar = async (id) => {
        try{
            setLoading(true)
            await services.apiAuto.deleteNoticia(id)
            update()
        } catch(e){
            showMsgE(e.response.data)
        } finally{
            setLoading(false)
        }
    }

    const history = useHistory();
    
    return (
        <div className={styles.wrapper}>
            <div className={styles.title}>
                Nome:
            </div>
            <div className={styles.info}>
                {usuario.nome}
            </div>
            <div className={styles.title}>
                Período:
            </div>
            <div className={styles.info}>
                { (usuario.periodoIndetermidado) ? "Indetermidado" : moment(usuario.dataTermino).format("DD/MM/YYYY") }
            </div>
            <div className={styles.title}>
                Ordem
            </div>
            <div className={styles.info}>
                { usuario.ordem }
            </div>
            <div className={styles.actionWrapper}>

                { usuario.status === 1 && (<div className={styles.encerrado}>ATIVO</div>) }
                { usuario.status === 0 && (<div className={styles.andamento}>INATIVO</div>) }
                <button className={styles.editar} onClick={() => { apagar(usuario.id) }}>
                    Inativar
                    <FontAwesomeIcon icon={faTimes} className={styles.icon}/>
                </button>
                <button className={styles.editar} onClick={() => {history.push(`/noticias/detalhes?noticia=${usuario.id}`)}}>
                    Editar
                    <FontAwesomeIcon icon={faUpload} className={styles.icon}/>
                </button>
            </div>
        </div>
    )
}

export default Card